import { render, staticRenderFns } from "./LessonEdit.vue?vue&type=template&id=076d33cb&scoped=true&"
import script from "./LessonEdit.vue?vue&type=script&lang=js&"
export * from "./LessonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076d33cb",
  null
  
)

export default component.exports